import { useNavigate } from 'react-router';
import { AuthApi } from '../../../api';
import { ToastStateHandler } from '../../../api/utils/ToastStateHandler';
import { useContainer } from '../../useContainer';
import { useJoinToken } from '../useJoinToken';
import { useTranslation } from '../../useTranslation';

export interface ConfirmSignUpValues {
    username: string;
    confirmationCode: string;
}

const useHttpConfirmSignUp = () => {
    const { t } = useTranslation('newNotifications');
    const authApi: AuthApi = useContainer(AuthApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);
    const navigate = useNavigate();

    const { getJoinTokenAsQuery } = useJoinToken();

    const exec = (confirmSignUp: ConfirmSignUpValues) => {
        const { exec, clearCache, abort } = authApi.confirmSignUp({
            body: {
                email: confirmSignUp.username,
                confirmationCode: confirmSignUp.confirmationCode,
            },
            onSuccess: () => {
                toastHandler.push('success', t('auth.accountVerificationTitle'), t('auth.accountVerificationMessage_Success'));
                navigate(`/sign-in${getJoinTokenAsQuery(true)}`);
                clearCache();
            },
            onError: () => {
                toastHandler.push('error', t('auth.accountVerificationTitle'), t('auth.accountVerificationMessage_Failed'));
            },
        });
        exec();
        return abort;
    };

    return {
        exec,
    };
};

export default useHttpConfirmSignUp;
